export default __webpack_public_path__ + "static/media/oxygen-generator.b33eac03.jpg";